import { Stack, Typography, useTheme } from '@mui/material';
import { CaretRight, FileText } from '@phosphor-icons/react';

import {
  AccordionDetailsStyled,
  AccordionStyled,
  AccordionSummaryStyled,
  BenefitDocumentsListItemStyled,
  BenefitDocumentsListItemTextWrapperStyled,
  BenefitDocumentsListStyled,
  LinkWrapperStyled,
} from './BenefitDocumentsListStyled';
import { BenefitDocument } from '../../types';
import { useConfigurationQuery } from 'theSource/queries';
import { Link } from 'theSource/components';

export interface BenefitDocumentsListProps {
  title: string;
  data: BenefitDocument[];
  hideTitle: boolean;
}

export const BenefitDocumentsList = ({
  data,
  title,
  hideTitle = false,
}: BenefitDocumentsListProps) => {
  const theme = useTheme();
  const { configuration } = useConfigurationQuery();

  const renderAccordion = (children: any, title: string) => {
    return (
      <AccordionStyled
        data-testid="benefit-document-folder"
        defaultExpanded={false}
        disableGutters
      >
        <AccordionSummaryStyled expandIcon={<CaretRight size={20} />}>
          <Typography variant="body2">{title}</Typography>
        </AccordionSummaryStyled>
        <AccordionDetailsStyled>
          <Stack spacing={theme.spacing(1)}>
            <BenefitDocumentsList
              data={children}
              title={title}
              hideTitle={true}
            />
          </Stack>
        </AccordionDetailsStyled>
      </AccordionStyled>
    );
  };

  if (data.length > 0) {
    return (
      <BenefitDocumentsListStyled data-testid="benefit-documents-list">
        {!hideTitle && <h2 className="headline-3">{title}</h2>}
        {data.map((file) => (
          <BenefitDocumentsListItemStyled
            data-testid="benefit-documents-list-item"
            key={file.key}
          >
            {file.folder === true ? (
              ''
            ) : (
              <FileText
                size={24}
                weight="duotone"
                color={theme.palette.grey[500]}
              />
            )}
            <BenefitDocumentsListItemTextWrapperStyled>
              {file.folder === true ? (
                <>
                  {file.children.length > 0 &&
                    renderAccordion(file.children, file.title)}
                </>
              ) : (
                <>
                  <LinkWrapperStyled>
                    <Link
                      path={`${configuration?.apiHost}${file.fileUrl}`}
                      value={file.title}
                      target="_blank"
                      download
                    />
                  </LinkWrapperStyled>
                  <Typography variant="caption">{file.updatedAt}</Typography>
                </>
              )}
            </BenefitDocumentsListItemTextWrapperStyled>
          </BenefitDocumentsListItemStyled>
        ))}
      </BenefitDocumentsListStyled>
    );
  } else {
    return (
      <BenefitDocumentsListStyled data-testid="benefit-documents-list"></BenefitDocumentsListStyled>
    );
  }
};
